import { colors } from '../const';
import { runCommandInteractive } from './exec';

export async function runVercelDeploy(useNpx: boolean, hasToken: boolean): Promise<void> {
  console.log(`\n${colors.dim}Step 4/4: Deploying project to production...${colors.reset}`);
  
  const deployArgs = ['--prod', '--yes'];
  if (hasToken) {
    deployArgs.push('--token', process.env.VERCEL_TOKEN!);
  }

  const deployCmd = useNpx ? 'npx' : 'vercel';
  const finalDeployArgs = useNpx ? ['--yes', 'vercel', ...deployArgs] : deployArgs;

  console.log(`${colors.cyan}⚡ Running deployment in: ${process.cwd()}${colors.reset}\n`);

  const deployExitCode = await runCommandInteractive(deployCmd, finalDeployArgs);
  if (deployExitCode !== 0) {
    throw new Error('Vercel deployment failed.');
  }

  console.log(`\n${colors.bold}${colors.green}🎉 Deployment completed successfully!${colors.reset}\n`);
}
